import logo from "./logo.svg";
import "./App.css";

import Website from "./AlbumBu";

function App() {
  return (
    <div className="App">
      <Website></Website>
      {/* <StoreBuilder></StoreBuilder> */}
      {/* <Album></Album> */}
      {/*<ScriptBuilder></ScriptBuilder>*/}
      {/* <div style={{ marginLeft: "50px" }}>
        <LikeHatesBuilder items={myItems} />
      </div> */}
    </div>
  );
}

export default App;
